// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"8251ffd4","791":"f0a90081"}[chunkId] + ".chunk.js";
};